"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useHeadroom } from "../../../../../hooks/useHeadroom.js";
import Container from "../../../../layout/Container/Container.js";
import Group from "../../../../layout/Group/Group.js";
import { useListState } from "@mantine/hooks";
import { L as LocalNavbarStyles } from "../../../../../LocalNavbar.module-D_uZkV8K.js";
import DesktopNavbar from "./parts/DesktopNavbar/DesktopNavbar.js";
import MobileNavbar from "./parts/MobileNavbar.js";
const LocalNavbar = (props) => {
  const {
    logo = {
      icon: "IdaLogo",
      href: "/",
      target: "_self"
    },
    links,
    transparent = false,
    mod,
    isLoading,
    isMenuOpen,
    openMenu,
    user,
    style,
    search,
    showUserLogin,
    ...rest
  } = props;
  const showHeader = useHeadroom({
    fixedAt: 120
  });
  const [openDropdowns, openDropdownsHandlers] = useListState(links == null ? void 0 : links.map(() => false));
  return /* @__PURE__ */ jsx(
    Group,
    {
      className: LocalNavbarStyles.root,
      mod: {
        transparent,
        show: showHeader,
        "with-links": links && links.length > 0 || false,
        "with-open-menu": isMenuOpen || openDropdowns.includes(true),
        ...mod
      },
      style,
      children: /* @__PURE__ */ jsxs(Container, { size: "global", className: LocalNavbarStyles.container, center: true, children: [
        /* @__PURE__ */ jsx(
          DesktopNavbar,
          {
            visibleFrom: "lg",
            user,
            ...rest,
            openDropdowns,
            openDropdownsHandlers,
            logo,
            links,
            search,
            isLoading,
            showUserLogin
          }
        ),
        /* @__PURE__ */ jsx(
          MobileNavbar,
          {
            hiddenFrom: "lg",
            ...rest,
            logo,
            showUserLogin,
            links,
            search,
            openMenu,
            isMenuOpen,
            isLoading
          }
        )
      ] })
    }
  );
};
export {
  LocalNavbar as default
};
